import React from 'react';
import FormField from '../../components/ui/FormField';
import { Input, NumberInput, DateInput } from '../../components/ui/Input';
import UserPicker from '../../components/shared/UserPicker';

export default function AssetFormInner({ form, update, errors }) {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      <FormField label="Asset Name" required error={errors.name}>
        <Input
          value={form.name}
          onChange={(e) => update({ name: e.target.value })}
          placeholder="e.g. MacBook Pro 14"
          error={!!errors.name}
        />
      </FormField>

      <FormField label="Category" required error={errors.category}>
        <Input
          value={form.category}
          onChange={(e) => update({ category: e.target.value })}
          placeholder="e.g. Laptop, Monitor, Phone"
          error={!!errors.category}
        />
      </FormField>

      <FormField label="Serial Number" required error={errors.serialNumber}>
        <Input
          value={form.serialNumber}
          onChange={(e) => update({ serialNumber: e.target.value })}
          placeholder="Unique identifier"
          error={!!errors.serialNumber}
        />
      </FormField>

      <FormField
        label="Assign To (optional)"
        hint="Leave empty to create as Available"
      >
        <UserPicker
          value={form.assignedTo || ''}
          onChange={(v) => update({ assignedTo: v || '' })}
          placeholder="Unassigned"
        />
      </FormField>

      <FormField
        label="Purchase Cost"
        required
        error={errors.purchaseCost}
      >
        <NumberInput
          value={form.purchaseCost}
          onChange={(e) => update({ purchaseCost: e.target.value })}
          min="0"
          step="0.01"
          placeholder="0.00"
          error={!!errors.purchaseCost}
        />
      </FormField>

      <FormField
        label="Purchase Date"
        required
        error={errors.purchaseDate}
      >
        <DateInput
          value={form.purchaseDate}
          onChange={(e) => update({ purchaseDate: e.target.value })}
          error={!!errors.purchaseDate}
        />
      </FormField>

      <FormField
        label="Warranty Expiry"
        required
        error={errors.warrantyExpiry}
        className="md:col-span-2"
      >
        <DateInput
          value={form.warrantyExpiry}
          onChange={(e) => update({ warrantyExpiry: e.target.value })}
          error={!!errors.warrantyExpiry}
        />
      </FormField>
    </div>
  );
}
